import {memo, useState} from "react";
import {Box, Button, Divider, Typography, useMediaQuery} from "@mui/material"
import {useTranslation} from "react-i18next"

import {theme} from "../../../utils";
import TranslationMsg from "./transMessage";
import {VideoDialog} from "../components";
import {useSnackbar} from "../../../contexts";
import {RedirectDialog} from "../../../components";

const styles = {
    logoCard: {
        boxShadow: '0px 1px 5px 0px rgba(37, 37, 37, 0.12), 0px 2px 2px 0px rgba(37, 37, 37, 0.14), 0px 3px 1px -2px rgba(37, 37, 37, 0.20)',
        backgroundColor: "#fff",
        borderRadius: "8px",
        mt: "1rem",
        display: "flex",
        alignItems: "center",
        justifyContent: 'center'
    },
    rowButtonWrapper: {
        color: "#fff",
        width: "197px",
        height: "38.33px",
        textTransform: "capitalize",
        borderRadius: '8px'
    },
    disclaimerContainer: {
        minWidth: "330px",
        display: "flex",
        flex: 1
    },
    disclaimer: {
        fontWeight: 300,
        fontStyle: "italic",
        fontSize: "13px",
        lineHeight: "120%",
        letterSpacing: "0%",
        verticalAlign: "middle"
    }
}

interface IVendorInfoProps {
    infoData?: any;
    demoUrl?: any;
}

const VendorInfo = (props: IVendorInfoProps) => {
    const {infoData, demoUrl} = props
    const {t} = useTranslation();
    const isMobile = useMediaQuery(theme.breakpoints.down(700))
    const {showSnackbar} = useSnackbar();
    const [openToolDialog, setOpenToolDialog] = useState<boolean>(false)
    const [openVideoDialog, setOpenVideoDialog] = useState<boolean>(false)

    const logoSvg = infoData?.logo ? require(`../../../assets/images/svgs/${infoData?.logo}`) : ""

    const openTool = () => {
        const getCheckedVendors = localStorage.getItem("checkedVendors")
        const checkedVendorsList: any[] = getCheckedVendors ? JSON.parse(getCheckedVendors) : []
        const isModalShown = checkedVendorsList?.includes(infoData?.vendorId)
        setOpenToolDialog(!isModalShown)
        if (isModalShown && infoData?.redirectURL) {
            const url = infoData?.redirectURL
            if (url) {
                window.open(`https://${url}`, '_blank', 'noopener,noreferrer');
            } else {
                showSnackbar("redirect uri is not available!", "error")
            }
        }
    }

    return (
        <>
            <Box display={"flex"} gap={"40px"} mb={"40px"} pt={"20px"}>
                <Box sx={[styles.logoCard, {
                    p: isMobile ? "0px" : "46px",
                    height: isMobile ? "82px" : null,
                    width: isMobile ? "82px" : null,
                    px: isMobile ? "19px" : "46px"
                }]}>
                    {infoData?.logo ?
                        <img src={logoSvg}
                             style={{width: isMobile ? "50px" : "110px", height: isMobile ? "50px" : "110px"}}
                             alt="vendor-logo"/> : null
                    }
                </Box>
                <Box display={"flex"} flexDirection={"column"} justifyContent={"space-between"} pr={"20px"}>

                    <Typography
                        sx={{...theme.typography.poppinsH1, mt: "8px"}}>
                        {infoData?.title}
                    </Typography>
                    <Typography
                        sx={{...theme.typography.poppinsBodyLight, fontSize: '20px', py: "14px", maxWidth: "678px"}}>
                        {infoData?.description}
                    </Typography>

                    <Box sx={{display: "flex", flexDirection: "column", gap: "1rem", width: "100%"}}>

                        <Box sx={{display: "flex", gap: "1rem", width: "fit-content"}}>
                            <Button
                                variant="contained"
                                onClick={openTool}
                                sx={[styles.rowButtonWrapper, {backgroundColor: "#4B69F1"}]}
                            >
                                <Typography sx={{...theme.typography.components.montseratButtonContainedLabel}}>
                                    {t(TranslationMsg.OPEN_TOOL_BUTTON_LABEL)}
                                </Typography>
                            </Button>

                            <Button
                                onClick={() => demoUrl && setOpenVideoDialog(true)}
                                variant="outlined"
                                sx={[styles.rowButtonWrapper, {borderColor: "#000", color: "#000"}]}
                            >
                                <Typography sx={{...theme.typography.components.montseratButtonOutlinedLabel}}>
                                    {t(TranslationMsg.WATCH_DEMO_BUTTON_LABEL)}
                                </Typography>
                            </Button>
                        </Box>

                        {/* Right half (disclaimer) */}
                        <Box sx={{...styles.disclaimerContainer}}>
                            <Box sx={{...theme.typography.poppinsBodyRegular, ...styles.disclaimer, flex: 1}}>
                                The content on this page and demo videos were created by third-party AI vendors to describe the offerings available on their websites. Astellas does not control or assume responsibility for the content, products, or services available on the third-party AI vendor websites. The GA AI tools are not diagnostic tools and are not intended for the diagnosis or treatment of any disease or medical condition.
                            </Box>
                        </Box>
                    </Box>
                </Box>
            </Box>
            {infoData ?
                <Divider/>
                : null
            }
            <RedirectDialog
                showDialog={openToolDialog}
                vendorItem={infoData}
                onCloseRedirectDialog={() => setOpenToolDialog(false)}/>
            <VideoDialog
                videoUrl={demoUrl}
                showDialog={openVideoDialog}
                onCloseVideoDialog={() => setOpenVideoDialog(false)}/>
        </>
    )
}

export default memo(VendorInfo)